import React from "react";

const ClasePage = () => {
  const gradinita = [
    {
      locatie: "Grădinița cu program prelungit Ulmeni",
      educatori: [
        "Țicle Daniela",
        "Coroian Andreea-Amalia",
        "Sav Elvira Lucica",
      ],
    },
    {
      locatie: "Grădiniță Structura Mânău",
      educatori: [
        "Pop Andreea Liliana - secția română",
        "Tamas Erzsebet - secția maghiară",
      ],
    },
    {
      locatie: "Grădiniță Structura Someș-Uileac",
      educatori: ["Cozma Ștefania-Florica"],
    },
  ];

  const primarUlmeni = [
    { clasa: "Clasa pregătitoare", profesor: "Pop Daniela-Grațiela" },
    { clasa: "Clasa I", profesor: "Sas Dacian" },
    { clasa: "Clasa II", profesor: "Băeș Monica-Maria" },
    { clasa: "Clasa III", profesor: "Mateașan Romana-Diana" },
    { clasa: "Clasa IV", profesor: "Mateaș Lavinia-Mihaela " },
  ];
  const primarManau = [
    { clasa: "Clasele CP+III", profesor: "Molnar Anita-Monika" },
    { clasa: "Clasele I-II-IV", profesor: "Kis-Toth Melinda" },
  ];

  const gimnaziu = [
    {
      clasa: "Clasa a V-a A",
      diriginte: "Pop Daniel-Vasile",
    },
    {
      clasa: "Clasa a V-a B",
      diriginte: "Miklos Eniko-Beata",
    },
    {
      clasa: "Clasa a VI-a A",
      diriginte: "Țicle Andreea",
    },
    {
      clasa: "Clasa a VI-a B",
      diriginte: "Ionuți Bogdan Doru",
    },
    { clasa: "Clasa a VII-a A", diriginte: "Prună Ștefan-Paul" },
    {
      clasa: "Clasa a VII-a B",
      diriginte: "Rad Andreea Vasilica",
    },
    {
      clasa: "Clasa a VIII-a A",
      diriginte: "Beci Cristina-Veturia",
    },
    {
      clasa: "Clasa a VIII-a B",
      diriginte: "Moș Amalia-Oana-Alina",
    },
  ];

  const liceu = [
    {
      clasa: "Clasa a IX-a",
      diriginte: "Pinte Camelia-Gabriela",
    },
    {
      clasa: "Clasa a X-a",
      diriginte: "Covaciu Ioana-Georgiana",
    },
    {
      clasa: "Clasa a XI-a",
      diriginte: "Lupșa Simona",
    },
    {
      clasa: "Clasa a XII-a",
      diriginte: "Botiș Sorina-Mihaela",
    },
  ];

  const profesional = [
    {
      clasa: "Clasa a IX-a IP",
      diriginte: "Tohătan Anica",
    },
    {
      clasa: "Clasa a X-a IP",
      diriginte: "Pop Delia Cornelia",
    },
    {
      clasa: "Clasa a XI-a IP",
      diriginte: "Profeanu Crina",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <div className="mb-12">
          <h2 className="text-3xl font-bold mb-4">Învățământ preșcolar</h2>
          <table className="table-auto w-full border-collapse border border-gray-300">
            <tbody>
              {gradinita.map((item, index) => (
                <tr key={index}>
                  <td className="border border-gray-300 px-4 py-2 w-1/2">
                    {item.locatie}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 w-1/2">
                    {item.educatori.map((educator, idx) => (
                      <div key={idx}>{educator}</div>
                    ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mb-12">
          <h2 className="text-3xl font-bold mb-4">Învățământ primar</h2>
          <p className="mb-4 font-bold">Școala Primară Ulmeni</p>
          <table className="table-auto w-full border-collapse border border-gray-300 mb-6">
            <thead>
              <tr>
                <th className="border border-gray-300 px-4 py-2 w-1/2">
                  Clasa
                </th>
                <th className="border border-gray-300 px-4 py-2 w-1/2">
                  Învățător
                </th>
              </tr>
            </thead>
            <tbody>
              {primarUlmeni.map((item, index) => (
                <tr key={index}>
                  <td className="border border-gray-300 px-4 py-2 w-1/2">
                    {item.clasa}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 w-1/2">
                    {item.profesor}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="mb-4 font-bold">Școala Primară Mânău</p>
          <table className="table-auto w-full border-collapse border border-gray-300">
            <tbody>
              {primarManau.map((item, index) => (
                <tr key={index}>
                  <td className="border border-gray-300 px-4 py-2 w-1/2">
                    {item.clasa}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 w-1/2">
                    {item.profesor}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mb-12">
          <h2 className="text-3xl font-bold mb-4">Învățământ gimnazial</h2>
          <table className="table-auto w-full border-collapse border border-gray-300">
            <thead>
              <tr>
                <th className="border border-gray-300 px-4 py-2 w-1/3">
                  Clasa
                </th>
                <th className="border border-gray-300 px-4 py-2 w-1/3">
                  Diriginte
                </th>
              </tr>
            </thead>
            <tbody>
              {gimnaziu.map((item, index) => (
                <tr key={index}>
                  <td className="border border-gray-300 px-4 py-2 w-1/3">
                    {item.clasa}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 w-1/3">
                    {item.diriginte}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mb-12">
          <h2 className="text-3xl font-bold mb-4">Învățământ liceal</h2>
          <table className="table-auto w-full border-collapse border border-gray-300">
            <tbody>
              {liceu.map((item, index) => (
                <tr key={index}>
                  <td className="border border-gray-300 px-4 py-2 w-1/3">
                    {item.clasa}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 w-1/3">
                    {item.diriginte}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div>
          <h2 className="text-3xl font-bold mb-4">Învățământ profesional</h2>
          <table className="table-auto w-full border-collapse border border-gray-300">
            <tbody>
              {profesional.map((item, index) => (
                <tr key={index}>
                  <td className="border border-gray-300 px-4 py-2 w-1/3">
                    {item.clasa}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 w-1/3">
                    {item.diriginte}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>
    </div>
  );
};

export default ClasePage;
